export default __webpack_public_path__ + "static/media/windows.1e4677e2.svg";